import React from "react";
import {
  BsPeopleFill,
  BsFillEmojiSmileFill,
  BsCameraFill,
} from "react-icons/bs";
import { AiOutlineGif } from "react-icons/ai";
import { GiDiamondsSmile } from "react-icons/gi";
import { RiChatSmile3Fill } from "react-icons/ri";

import { IconButton } from "components/buttons/Buttons";

const PostActionButtons = () => {
  return (
    <div className="border-y mt-3  border-gray-500 flex justify-between items-center">
      {" "}
      <IconButton name={"Like"} icon={<BsPeopleFill />} />
      <IconButton name={"Comment"} icon={<BsPeopleFill />} />
      <IconButton name={"Send"} icon={<BsPeopleFill />} />
    </div>
  );
};

export default PostActionButtons;

export const PostCommentBox = ({ avatar }) => {
  return (
    <div className="flex justify-start items-center my-2">
      <img
        className="h-8 w-8 mr-2 object-contain rounded-full cursor-pointer"
        src={avatar}
      />
      <label
        htmlFor="comment"
        className=" p-2 w-full flex justify-end items-center rounded-full  bg-[#3A3B3C] overflow-hidden"
      >
        <input
          id="comment"
          type="text"
          placeholder="Write an answer"
          className="h-full w-full bg-[#3A3B3C] outline-none text-gray-400"
        />
        {commentIconList?.map((button, index) => (
          <span
            key={index}
            className="text-sm mr-1 p-1 text-gray-400 cursor-pointer"
          >
            {button?.icon}
          </span>
        ))}
      </label>
    </div>
  );
};

const commentIconList = [
  { icon: <RiChatSmile3Fill /> },
  { icon: <BsFillEmojiSmileFill /> },
  { icon: <BsCameraFill /> },
  { icon: <AiOutlineGif /> },
  { icon: <GiDiamondsSmile /> },
];
